<template>
    <div>
        <div class="mb-4 mt-4">
            <div class="checkbox-container">
                <input 
                    type="checkbox" 
                    :name="'renovacion-automatica-' + identificador"
                    :id="'renovacion-automatica-' + identificador" 
                    :value="value"
                    @input="updateValue($event.target.checked)" 
                />
                <label :for="'renovacion-automatica-' + identificador">
                    {{ $t('formularios.acepto_renovacion_automatica', { teatro: teatro.nombre }) }}, al marcar aceptas las <a href="#" @click.prevent="mostrarModalCondiciones" class="underline">condiciones legales</a>
                </label>
            </div>
        </div>

        <ModalComponent 
            :name="'modalCondiciones' + identificador"
            :title="$t('formularios.condiciones_renovacion_automatica') + ' ' + teatro.nombre"
            @close="CerrarModalCondiciones"
        >

            <div class="card-body">
                <div v-html="lista_abonados.renovacion_condiciones"></div>
            </div>
        </ModalComponent>
    </div>
</template>

<script>
    import ModalComponent from '@/components/backend/components/ModalComponent.vue';

    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            identificador: {
                type: [String, Number],
                required: true
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        methods: {
            updateValue(checked) {
                this.$emit('input', checked);
            },
            mostrarModalCondiciones() {
                this.$modal.show('modalCondiciones' + this.identificador);
            },
            CerrarModalCondiciones() {
                this.$modal.hide('modalCondiciones' + this.identificador);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
<style scoped>
    .underline{
        text-decoration: underline;
    }
</style>